import React from "react";
import Button from "react-bootstrap/Button";
import NavBar from "./reusable-components/nav-bar";
import Rectangle from '../images/Rectangle.png';
import Footer from "./reusable-components/footer";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PersonaliseBG from '../images/personaliseBG.png';
import IQOSWHITE from '../images/IQOS-white.png';
import IQOSBLACK from '../images/IQOS-black.png';
import IQOSCOPPER from '../images/IQOS-copper.png';
import HowToUse from '../components/reusable-components/HowToUse';
import { Link } from 'react-router-dom';
import FindAStore from '../components/reusable-components/FindAStore';
import TobaccoMeetsTech from '../images/TobaccoMeetsTech.png';
import ConnectExpert from "./reusable-components/connectWithExpert";
import Rewards from "./reusable-components/rewards";
import IQOSCommunity from "./reusable-components/iqosCommunity";
import ReferAFriend from "./reusable-components/referFriend";
import HarshChemicalsBG from '../images/harshChemicalsBG.png';
import MyIQOSTab from "./reusable-components/myIQOSTab";

function Homepage() {
    return (
        <div>
            <div>
                <NavBar />
            </div>
            <div >
                <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
            </div>
            <div style={{
                height: '230px',
                backgroundColor: 'FAF8FF',
                backgroundImage: `url(${TobaccoMeetsTech})`,
                backgroundRepeat: 'no-repeat'
            }}>
                <div style={{

                    textAlign: 'left',
                    backgroundColor: 'FAF8FF',
                    color: '#475666',
                    paddingTop: '85px',
                    paddingLeft: '20px'
                }}>
                    <div style={{
                        fontSize: '17px',
                        fontWeight: '700',
                        font: 'Sintony'

                    }}>
                        WHERE TOBACCO<br></br> MEETS TECHNOLOGY
                    </div>
                    <div style={{
                        marginTop: '10px'
                    }}>
                        <Button variant="success" size="lg" type="submit" style={{
                            height: '43px',
                            width: '123px',
                            fontSize: '12px',
                            borderRadius: '0',
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF',
                            backgroundColor: '#00A78A'

                        }} >
                            SHOP IQOS
                        </Button>
                    </div>
                </div>
            </div>

            <div style={{ paddingBottom: '20px' }}>
                <Row>
                    <Col style={{
                        marginLeft: '20px',
                        marginTop: '2px'
                    }}>
                        <Link to="/how-to-use-page">
                            <HowToUse />
                        </Link>
                    </Col>
                    <Col>
                        <ConnectExpert />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Link to="/rewardsPage">
                            <Rewards />
                        </Link>
                    </Col>
                    <Col >
                        <Link to="/communityPage" >
                            <IQOSCommunity />
                        </Link>
                    </Col>
                </Row>
            </div>
            <div style={{
                font: 'Sintony',
                fontSize: '14px',
                lineHeight: '18.24px',
                color: '#475666',
                textAlign: 'center',
                fontWeight: '700',
                marginBottom: '40px',
                marginTop: '40px'
            }}>
                <span>DASHBOARD</span>


                <MyIQOSTab />

            </div>
            <div style={{
                height: '250px',
                backgroundImage: `url(${HarshChemicalsBG})`,
                backgroundRepeat: 'no-repeat'
            }}>
                <div style={{

                    textAlign: 'left',

                    color: '#FFFFFF',
                    paddingTop: '85px',
                    paddingLeft: '20px'
                }}>
                    <div style={{
                        fontSize: '17px',
                        fontWeight: '700',
                        font: 'Sintony',
                        lineHeight: '21px'

                    }}>
                        IQOS helps reduce <br></br>
                        exposure to harsh<br></br>
                        chemicals
                    </div>
                    <div style={{
                        marginTop: '10px'
                    }}>
                        <Button variant="outline-secondary" size="lg" type="submit" style={{
                            height: '43px',
                            width: '123px',
                            fontSize: '12px',
                            borderRadius: '0',
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF'

                        }} >
                            LEARN MORE
                        </Button>
                    </div>
                </div>
            </div>
            <div style={{
                // marginBottom: '30px'
            }}>
                <div style={{
                    font: 'Sintony',
                    fontSize: '14px',
                    lineHeight: '18.24px',
                    color: '#475666',
                    textAlign: 'center',
                    fontWeight: '700',
                    marginBottom: '40px'
                }}>
                    <span>MEET IQOS</span>
                </div>
                <Row>
                    <Col style={{
                        textAlign: 'center'
                    }}>
                        <img src={IQOSWHITE} style={{ width: '76px', height: '136px' }} alt="" />
                    </Col>

                    <Col style={{
                        textAlign: 'center'
                    }}>
                        <img src={IQOSBLACK} style={{ width: '76px', height: '136px' }} alt="" />
                    </Col>

                    <Col style={{
                        textAlign: 'center'
                    }}>
                        <img src={IQOSCOPPER} style={{ width: '76px', height: '136px' }} alt="" />
                    </Col>
                </Row>
                <Row style={{
                    marginTop: '10px',
                    marginBottom: '20px'
                }}>
                    <Col style={{
                        fontSize: '11px',
                        lineHeight: '15px',
                        textAlign: 'center'
                    }}>
                        IQOS 3 DUO KIT
                        WHITE
                    </Col>

                    <Col style={{
                        fontSize: '11px',
                        lineHeight: '15px',
                        textAlign: 'center'
                    }}>
                        IQOS 3 DUO KIT <br></br>
                        BLACK
                    </Col>

                    <Col style={{
                        fontSize: '11px',
                        lineHeight: '15px',
                        textAlign: 'center'
                    }}>
                        IQOS 3 DUO KIT
                        COPPER
                    </Col>
                </Row>

            </div>
            <div style={{
                height: '250px',
                backgroundImage: `url(${PersonaliseBG})`,
                backgroundRepeat: 'no-repeat'
            }}>
                <div style={{

                    textAlign: 'left',

                    color: '#FFFFFF',
                    paddingTop: '85px',
                    paddingLeft: '20px'
                }}>
                    <div style={{
                        fontSize: '17px',
                        fontWeight: '700',
                        font: 'Sintony'

                    }}>
                        Personalize <br></br>
                        your IQOS
                    </div>
                    <div style={{
                        marginTop: '10px'
                    }}>
                        <Button variant="outline-secondary" size="lg" type="submit" style={{
                            height: '43px',
                            width: '123px',
                            fontSize: '12px',
                            borderRadius: '0',
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF'

                        }} >
                            GET STARTED
                        </Button>
                    </div>
                </div>
            </div>
            <div>
                <Row>

                    <Col>
                        <Link to="./FindAStore" />   <FindAStore />
                    </Col>

                    <Col>
                        <ReferAFriend />
                    </Col>
                </Row>

            </div>
            <Footer />
        </div >
    );
}

export default Homepage;